import { Space } from "antd";
import styled from "styled-components";
import { BottomNavBg } from "@assets";

export const Container = styled(Space)`
	width: 100%;
	max-width: 480px;
	padding: 12px 0 10px;
	align-items: flex-end;
	text-align: center;
	background-image: url(${BottomNavBg});
	background-repeat: no-repeat;
	background-size: 100%;
	.ant-space-item {
		flex: 0.25;
	}
	position: fixed;
	bottom: 0;
	margin-bottom: 0;
	z-index: 600;
	background-size: cover;
	
	@media screen and (max-width: 353px){
		svg {
			width: 16px;
			height: 16px;
		}
	}
	@media screen and (max-width: 378px ) and (min-width: 358px){
		padding: 10px 0px 10px;
	}
`;

export const ItemContainer = styled.div`
	/* height: 65px; */
	display: flex;
	flex-direction: column;
	align-items: center;
	div {
		visibility: ${props => props.index === 2 ? 'hidden' :'show'} ;
	}
	svg {
		visibility: ${props => props.index === 2 ? 'hidden' :'show'} ;
	}
`;

export const ItemWrapper = styled.div`
	margin-top: 8px;
	text-align: center;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	gap: 0;
	@media screen and (max-width: 360px){
		margin-top:	0px;
		margin-bottom: 4px;
	}
`;

export const Label = styled.div`
	font-size: 10px;
	font-style: normal;
	letter-spacing: normal;
	line-height: 1.5;
	font-weight: 400;
	color: ${(props) => (props.status === "active" || props.index === 2 ? "#FFFFFF" : "#8FDCFF")};

	@media screen and (max-width: 367px) {
		font-size: 8px !important;
	}
`;


